<div class="container-full bg-theme">
  <div class="container">
    <div class="columns">
      <div class="column is-12">
        <div
          class="temporary-item temporary-breadcrumbs"
          *ngIf="!breadcrumbLinks"
        ></div>
        <app-breadcrumbs
          [darkTheme]="true"
          [breadcrumbLinks]="breadcrumbLinks"
          *ngIf="breadcrumbLinks"
        ></app-breadcrumbs>
        <h1
          class="title is-2 m-b-gutter m-t-md has-text-white"
          *ngIf="principle"
        >
          Posts related to AI principle : "{{ principle.name }}"
        </h1>
      </div>
    </div>
  </div>
</div>

<div class="container m-t-alt" *ngIf="principle">
  <div class="columns flex flex-wrap">
    <p *ngIf="posts && !posts.length">
      No posts found tagged with {{ principle.name }}
    </p>

    <div
      class="column is-12-mobile is-6-tablet is-4-desktop"
      *ngFor="let post of posts"
    >
      <app-post-card [post]="post"></app-post-card>
    </div>
    <div
      class="column is-12-mobile is-6-tablet is-4-desktop"
      *ngIf="loadingPosts"
    >
      <div class="lc lc--regular">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div
      class="column is-12-mobile is-6-tablet is-4-desktop"
      *ngIf="loadingPosts"
    >
      <div class="lc lc--regular">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div
      class="column is-12-mobile is-6-tablet is-4-desktop"
      *ngIf="loadingPosts"
    >
      <div class="lc lc--regular">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div
      class="column is-12-mobile is-6-tablet is-4-desktop"
      *ngIf="loadingPosts"
    >
      <div class="lc lc--regular">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div
      class="column is-12-mobile is-6-tablet is-4-desktop"
      *ngIf="loadingPosts"
    >
      <div class="lc lc--regular">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div
      class="column is-12-mobile is-6-tablet is-4-desktop"
      *ngIf="loadingPosts"
    >
      <div class="lc lc--regular">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</div>
